import { render, staticRenderFns } from "./MessAge.vue?vue&type=template&id=51671ef8&scoped=true&"
import script from "./MessAge.vue?vue&type=script&lang=js&"
export * from "./MessAge.vue?vue&type=script&lang=js&"
import style0 from "./MessAge.vue?vue&type=style&index=0&id=51671ef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51671ef8",
  null
  
)

export default component.exports